module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qabdo2-4aecca80df3d0c6ea40d7abed72c4049.jpg";